import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'foundations-components/transitional/components/Link';
import { getAudienceDetailsUrl } from 'audiences-data/utils/urls';
import useAudienceName from '../hooks/useAudienceName';
import { jsx as _jsx } from "react/jsx-runtime";
const AudienceName = ({
  audienceId,
  showAsLink,
  showSpinner = true,
  onError
}) => {
  const {
    audienceName,
    loading,
    error
  } = useAudienceName(audienceId, {
    onError
  });
  if (loading) {
    return showSpinner ? /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small"
    }) : null;
  }
  if (error) {
    return null; // Error can be handled in `onError`
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "audience-name",
    children: showAsLink ? /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getAudienceDetailsUrl(audienceId),
      children: audienceName
    }) : audienceName
  });
};
export default AudienceName;